export const useMascara = () => {
    function mascaraTelefone(v: string) {
      if(!v || v.length >= 15) {
        return v;
      }

      let r = v.replace(/\D/g, "");
      r = r.replace(/^0/, "");
    
      if (r.length > 11) {
        r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
      } else if (r.length > 7) {
        r = r.replace(/^(\d\d)(\d{5})(\d{0,4}).*/, "($1) $2-$3");
      } else if (r.length > 2) {
        r = r.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
      } else if (v.trim() !== "") {
        r = r.replace(/^(\d*)/, "($1");
      }
      return r;
  }

  function mascaraHexadecimal(hex: string) {
    hex = hex.replace(/[^0-9a-fA-F]/g, "");
    
    if (hex.length > 6) {
        hex = hex.substring(0, 6);
    }

    return `#${hex}`;
  }

  function mascaraCPF(cpf: string){
      if(!cpf) {
        return cpf;
      }
      cpf=cpf.replace(/\D/g,"")
      cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
      cpf=cpf.replace(/(\d{3})(\d)/,"$1.$2")
      cpf=cpf.replace(/(\d{3})(\d{1,2})$/,"$1-$2")
      return cpf
  }

  function mascaraCNPJ(cnpj: string){
    if(!cnpj) {
      return cnpj;
    }
    // CNPJ alfanumérico: 12 posições alfanuméricas (A-Z, 0-9) + 2 dígitos verificadores numéricos.
    cnpj = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, "")
    const base = cnpj.slice(0, 12)
    const dv = cnpj.slice(12, 14).replace(/[^0-9]/g, "")
    cnpj = base + dv
    cnpj = cnpj.replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2")
    cnpj = cnpj.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3")
    cnpj = cnpj.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, ".$1/$2")
    cnpj = cnpj.replace(/([A-Z0-9]{4})([A-Z0-9])/, "$1-$2")
    return cnpj
  }

  function mascaraCEP(cep: string){
    if(!cep) {
      return cep;
    }
    cep=cep.replace(/\D/g,"")
    cep=cep.replace(/(\d{5})(\d)/,"$1-$2")
    return cep
  }

  /**
   * Formata telefone para o padrão brasileiro: (41) 99907-3080
   * Aceita formatos: 5541999073080, 41999073080, (41) 99907-3080, etc.
   */
  function formatarTelefoneParaPadrao(telefone: string | undefined | null): string | undefined {
    if (!telefone) {
      return undefined;
    }

    // Remove todos os caracteres não numéricos
    let numeros = telefone.replace(/\D/g, "");

    // Remove código do país (55) se presente
    if (numeros.length > 11 && numeros.startsWith("55")) {
      numeros = numeros.substring(2);
    }

    // Remove zeros à esquerda
    numeros = numeros.replace(/^0+/, "");

    // Formata baseado no tamanho
    if (numeros.length === 11) {
      // Celular: (41) 99907-3080
      return numeros.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
    } else if (numeros.length === 10) {
      // Fixo: (41) 3333-3333
      return numeros.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
    } else if (numeros.length > 0) {
      // Tenta formatar mesmo que não tenha o tamanho ideal
      if (numeros.length >= 10) {
        const ddd = numeros.substring(0, 2);
        const resto = numeros.substring(2);
        if (resto.length >= 8) {
          const parte1 = resto.substring(0, resto.length - 4);
          const parte2 = resto.substring(resto.length - 4);
          return `(${ddd}) ${parte1}-${parte2}`;
        }
      }
      // Se não conseguir formatar, retorna os números limpos
      return numeros;
    }

    return telefone; // Retorna original se não conseguir processar
  }

  return { mascaraCPF, mascaraTelefone, mascaraCNPJ, mascaraCEP, mascaraHexadecimal, formatarTelefoneParaPadrao}
}